import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import hasPermission from '../Shared/hasPermission';
import UpdatesModal from './UpdatesModal';
import MuteModal from './MuteModal';
import AssignUserToPracticeModal from './AssignUserToPracticeModal';
import PracticeWorkflow from '../Workflow/PracticeWorkflow';
import DaylightCodeMapper from './Daylight/DaylightCodeMapperModal/DaylightCodeMapper';
import PracticeScheduleModal from './PracticeScheduleModal';
import PracticeRelationsModal from './PracticeRelationsModal';
import PracticeConfigurationModal from './PracticeConfigurationModal';
import PluginOfferingManagerModal from './MissionControl/PluginOffering/PluginOfferingManagerModal';
import PluginClientManifestModal from './MissionControl/ClientManifest/PluginClientManifestModal';
import PluginClientManifestConfigurationModal from './MissionControl/ClientManifest/PluginClientManifestConfigurationModal';
import PluginClientAddingConfirmationModal from './MissionControl/ClientManifest/PluginClientAddingConfirmationModal';
import LeadsGenerationConfirmationModal from './LeadsGenerationConfirmationModal';

const AllModals = () => {
    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canSyncScheduling = hasPermission(`SyncScheduling`, permissions);
    const canManageOfferings = hasPermission(`ManageOfferings`, permissions);
    const canConfiguration = hasPermission(`Configuration`, permissions);
    const canDaylightFlagForReview = hasPermission(
        `DaylightFlagForReview`,
        permissions
    );
    const canDaylightReview = hasPermission(`DaylightReview`, permissions);
    const canSeeDaylightCodeMapper =
        canDaylightFlagForReview || canDaylightReview;
    const canAddPluginOffering = hasPermission(
        'BitwerxOfferingPluginManagerEdit',
        permissions
    );
    const canEditClientPlugin = hasPermission(`ClientPluginsEdit`, permissions);
    const canManageLeadsGeneration = hasPermission('ManageLeadsGeneration', permissions);
    return (
        <>
            {/* TODO: conditionally render tied to open boolean? 
            check wont mess up the state for each modal */}
            {/* may be prudent to conditionally render all of these based on their toggle button permissions */}
            <UpdatesModal />
            <MuteModal />
            <AssignUserToPracticeModal />
            <PracticeWorkflow />
            {/* TODO: code mapper pretty broken still */}
            {canSeeDaylightCodeMapper && <DaylightCodeMapper />}
            {/* TODO: deeper refactor later */}
            {canSyncScheduling && <PracticeScheduleModal />}
            {/* TODO: deeper refactor later */}
            {canManageOfferings && <PracticeRelationsModal />}
            {/* TODO: deeper refactor later */}
            {canConfiguration && <PracticeConfigurationModal />}
            {/* Mission Control */}
            {canEditClientPlugin && <PluginClientManifestModal />}
            {canEditClientPlugin && <PluginClientManifestConfigurationModal />}
            {canEditClientPlugin && <PluginClientAddingConfirmationModal />}
            {canAddPluginOffering && <PluginOfferingManagerModal />}
            {/* Leads Generation */}
            {canManageLeadsGeneration && <LeadsGenerationConfirmationModal />}
        </>
    );
};

export default AllModals;
